// data/emojiHints.js
export const emojiHints = {
  // Dutch words
  kat: "🐱",
  boom: "💥",
  maan: "🌙",
  ster: "⭐️",
  boek: "📖",
  vis: "🐟",
  huis: "🏠",
  blad: "🍃",
  dak: "🏠",
  kind: "👶",
  stoel: "🪑",
  fles: "🍾",
  klok: "🕰️",
  straat: "🛣️",
  reep: "🍫",
  melk: "🥛",
  tuin: "🌷",
  voet: "🦶",
  deur: "🚪",
  vlag: "🚩",
  ring: "💍",
  neus: "👃",
  jas: "🧥",
  fiets: "🚲",
  kaas: "🧀",
  brief: "✉️",
  vloer: "🪵",
  oor: "👂",
  schoen: "👟",
  water: "💧",
  zout: "🧂",
  hand: "✋",
  tafel: "🛋️",
  broek: "👖",
  boter: "🧈",
  lamp: "💡",
  boomtak: "🌳",
  
  // English words (same emojis)
  cat: "🐱",
  tree: "🌳",
  moon: "🌙",
  star: "⭐️",
  book: "📖",
  fish: "🐟",
  house: "🏠",
  leaf: "🍃",
  roof: "🏠",
  child: "👶",
  chair: "🪑",
  bottle: "🍾",
  clock: "🕰️",
  street: "🛣️",
  strip: "🍫",
  milk: "🥛",
  garden: "🌷",
  foot: "🦶",
  door: "🚪",
  flag: "🚩",
  ring: "💍",
  nose: "👃",
  jacket: "🧥",
  bicycle: "🚲",
  cheese: "🧀",
  letter: "✉️",
  floor: "🪵",
  ear: "👂",
  shoe: "👟",
  salt: "🧂",
  hand: "✋",
  table: "🛋️",
  pants: "👖",
  butter: "🧈",
  lamp: "💡",
  branch: "🌳",

  // French words (same emojis)
  chat: "🐱",
  arbre: "🌳",
  lune: "🌙",
  étoile: "⭐️",
  livre: "📖",
  poisson: "🐟",
  maison: "🏠",
  feuille: "🍃",
  toit: "🏠",
  enfant: "👶",
  chaise: "🪑",
  bouteille: "🍾",
  horloge: "🕰️",
  rue: "🛣️",
  barre: "🍫",
  lait: "🥛",
  jardin: "🌷",
  pied: "🦶",
  porte: "🚪",
  drapeau: "🚩",
  bague: "💍",
  nez: "👃",
  veste: "🧥",
  vélo: "🚲",
  fromage: "🧀",
  lettre: "✉️",
  sol: "🪵",
  oreille: "👂",
  chaussure: "👟",  
  sel: "🧂",
  main: "✋",
  table: "🛋️",
  pantalon: "👖",
  beurre: "🧈",
  lampe: "💡",
  branche: "🌳"
};
